import { createAction, props } from '@ngrx/store';
import { ResponseEmailValidate, RequestEmailValidate } from '../../shared/interfaces';
import { EmailValidateTypes } from '../../shared/enums';

export const getEmailValidate = createAction(
    EmailValidateTypes.EMAIL_VALIDATE,
    props<{ request: RequestEmailValidate}>()
);

export const getEmailValidateSucess = createAction(
    EmailValidateTypes.EMAIL_VALIDATE_SUCCESS,
    props<{ response: ResponseEmailValidate }>()
);

export const getEmailValidateError = createAction(
    EmailValidateTypes.EMAIL_VALIDATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    EmailValidateTypes.CLEAN_STATE
);

